import FAQService from "../services/FAQService";

export const fetchFaqs = async (searchFaq, userId, csrfToken) => {
  try {
    // Always use the search endpoint, with or without keyword
    const result = await FAQService.searchFaqs(
      searchFaq || "",
      "",
      userId,
      csrfToken
    );

    // Handle the new API response structure
    if (result.payload) {
      // Return data in the format expected by existing components
      return result.payload.faqs || [];
    }

    // If there's an exception, return empty array
    if (result.exception) {
      console.error("FAQ API Exception:", result.exception);
      return [];
    }

    return [];
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    return [];
  }
};
